import { render } from "./cuisinedashboard.vue?vue&type=template&id=c6ee85ce"
import script from "./cuisinedashboard.vue?vue&type=script&lang=js"
export * from "./cuisinedashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__